export enum EUserManagementBranchRolesPageGetParams {
  Action = 'action',
}

export enum EUserManagementBranchRolesPageGetParamsActionTypes {
  Create = 'create',
}
